import React, {Component} from 'react';
import {Form, Field} from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import {FieldArray} from 'react-final-form-arrays'
import PropTypes from 'prop-types';

function confirm_remove_claim() {
  return confirm("Remove this claim?")
}

export default class TopTwentyForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  render = () => (
    <Form
      initialValues={ this.props.data }
      onSubmit={ this.props.onSubmit }
      mutators={{
        ...arrayMutators
      }}
      render={({
                 handleSubmit,
                 // mutators: {push, pop}, // injected from final-form-arrays above
                 pristine,
                 form,
                 submitting,
                 values
               }) => {
        return (
        <form onSubmit={handleSubmit}>
          <fieldset className="ir-search-double">

            <table id="creditors">
              <thead>
              <tr>
                <th rowSpan="2" colSpan="2">
                  <span class="label">Name of creditor and complete mailing address, including zip code</span>
                </th>
                <th rowSpan="2">
                  <span class="label">Name, telephone number, and email address of creditor contact</span>
                </th>
                <th rowSpan="2">
                  <span class="label">Nature of the claim</span>
                  <span class="schedule-tips">(for example, trade debts, bank loans, professional services, and government contracts)</span>
                </th>
                <th rowSpan="2">
                  <span class="label">Indicate if claim is contingent, unliquidated, or disputed</span>
                </th>
                <th colSpan="3">
                  <span class="label">Amount of unsecured claim</span>
                  <span class="schedule-tips">If the claim is fully unsecured, fill in only unsecured claim amount.
                  If amount is partially secured, fill in total claim amount and deduction for value of collateral or setoff to calculate unsecured claim.</span>
                </th>
              </tr>
              <tr>
                <th>Total claim, if partially secured</th>
                <th>Deduction for value of collateral or setoff</th>
                <th>Unsecured claim</th>
              </tr>
              </thead>
              <tbody>
              <FieldArray name="creditors">
                {({fields}) =>
                  fields.map((name, index) => (
                    <tr key={name}>
                      <td>
                        <div className="form-item">
                          <label>
                            <span className="label">{index+1}</span>
                          </label>
                        </div>
                      </td>        
                      <td>
                        <div className="form-item">
                          <Field name={`${name}.name_addr`} component="textarea"
                                 rows="4" cols="35" placeholder="Creditor Name and Address"
                          />
                        </div>
                      </td>
                      <td>
                        <div className="form-item">
                          <Field name={`${name}.contact_addr`} component="textarea"
                                 rows="4" cols="35" placeholder="Creditor Telephone and Email Contact"
                          />
                        </div>
                      </td>
                      <td>
                        <div className="form-item">
                          <Field name={`${name}.claim_type`} component="input" size="20"/>
                        </div>
                      </td>
                      <td>
                        <div className="form-item">
                          <Field name={`${name}.claim_status`} component="input" size="10"/>
                        </div>
                      </td>
                      <td className="money">
                        <div className="form-item">
                          $ <Field name={`${name}.total`} component="input" type="number" step="0.01" size="10"/>
                        </div>
                      </td>
                      <td className="money">
                        <div className="form-item">
                          $ <Field name={`${name}.deduction`} component="input" type="number" step="0.01" size="10"/>
                        </div>
                      </td>
                      <td className="money">
                        <div className="form-item">
                          $ <Field name={`${name}.unsecured`} component="input" type="number" step="0.01" size="10"/>
                        </div>
                      </td>


                      <td valign="top">
                        <span onClick={() => confirm_remove_claim() && fields.remove(index)}  style={{cursor: 'pointer'}}>
                          ❌
                        </span>
                      </td>
                    </tr>
                  ))}
              </FieldArray>
              </tbody>
            </table>

            <div className="editable">

              <button type="button" onClick={() => form.mutators.push('creditors', undefined)}>
                Add creditor
              </button>

            </div>


            <div className="buttons">

              <button type="submit" disabled={submitting || pristine} className="form-button form-submit">
                Submit
              </button>


              <button
                type="button"
                onClick={ () => { if(  pristine || confirm("You will lose unsaved changes") ) this.props.onCancel() } }
                disabled={submitting}>
                Cancel
              </button>

              <a style={{ float: 'right', color: 'gray', fontSize: '8px'}} onClick={() => alert(JSON.stringify(values, 0, 2)) }>
                Inspect Internal Structure</a>

            </div>
          </fieldset>

        </form>)
      }}
    />
  )
}


/** WEBPACK FOOTER **
 ** ./src/scheduleform/TopTwentyForm.jsx
 **/